$ = require 'jquery'
Dialog = require 'app/scripts/views/lib/dialog'
{ Key, registerShortcut, Scope, unregisterShortcut, } = require '@trello/keybindings'
PluginModalView = require 'app/scripts/views/plugin/plugin-modal-view'
PopOver = require 'app/scripts/views/lib/pop-over'
SidebarState = require 'app/scripts/view-models/sidebar-state'
{ track } = require '@trello/analytics'
{ registerClickOutsideHandler, unregisterClickOutsideHandler, ELEVATION_ATTR, getHighestVisibleElevation } = require '@trello/layer-manager'

module.exports = PluginModal = new class

  @modalView = null

  onShortcut: =>
    @close()
    track 'Keyboard Shortcuts', 'Esc - Hide Plugin Modal', 'Plugin Modal'

  handleClickOutside: =>
    @close()

  isOpen: -> @modalView?

  update: (content) ->
    if !@modalView?
      console?.warn('Warning: No modal open')
      return
    else if content.idPlugin != @modalView.content.idPlugin
      console?.warn('Can not update modal you did not open')
      return

    @modalView.update(content)

  open: (args) ->
    { model, content } = args

    PopOver.hide()
    SidebarState.hideUnpinnedSidebar()
    if Dialog.isVisible
      Dialog.hide(true)

    @close()

    @modalView = new PluginModalView({ model, content, fxClose: @close.bind(@) })

    $('.pop-over').before(@modalView.render().el)

    registerShortcut(@onShortcut, { scope: Scope.Dialog, key: Key.Escape })

    # Register an 'outside click' handler that takes elevations into account and increment the elevation
    # of the modal
    $chromeContent = $('.js-plugin-chrome-content')
    elevation = getHighestVisibleElevation() + 1
    $chromeContent.attr(ELEVATION_ATTR, elevation)
    registerClickOutsideHandler($chromeContent[0], @handleClickOutside)

    return

  close: ->
    if @isOpen()
      unregisterShortcut(@onShortcut)

      # Unregister the click outside handler and clear the elevation attribute
      $chromeContent = $('.js-plugin-chrome-content')
      $chromeContent.removeAttr(ELEVATION_ATTR)
      unregisterClickOutsideHandler($chromeContent[0], @handleClickOutside)

      @modalView.close()
      @modalView = null
    return